export default "__VITE_PUBLIC_ASSET__1943f00b__"